import {GameViews} from 'src/GameViews';
import {GameAvalancheReelsModule} from 'src/avalanche/GameAvalancheReelsModule';
import {AvalancheReelsModule} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsModule';
import {TopAvalancheReelsDropOutState} from 'src/topreels/states/TopAvalancheReelsDropOutState';
import {TopGameAvalancheRespinState} from 'src/topreels/states/TopGameAvalancheRespinState';
import {TopGameAvalancheAddSymbolsState} from 'src/topreels/states/TopGameAvalancheAddSymbolsState';
import {TopGameAvalancheRemoveWinsState} from 'src/topreels/states/TopGameAvalancheRemoveWinsState';
import {TopGameAvalancheReelsDropNewState} from 'src/topreels/states/TopGameAvalancheReelsDropNewState';
import {SymbolPosition} from '@fantasmagames/slot/src/modules/reels/ReelConstants';

export class TopReelsModule extends GameAvalancheReelsModule {

	protected setupViews(): void {
		this.setView(GameViews.TOP_REELS_VIEW);
	}

	protected setupStates(): void {
		super.setupStates();

		this.addState(new TopAvalancheReelsDropOutState(this, AvalancheReelsModule.DROPOUT_STATE));
		this.addState(new TopGameAvalancheAddSymbolsState(this, AvalancheReelsModule.ADD_SYMBOLS_STATE));
		this.addState(new TopGameAvalancheRespinState(this, AvalancheReelsModule.RESPIN_STATE));
		this.addState(new TopGameAvalancheRemoveWinsState(this, AvalancheReelsModule.REMOVE_WINS_STATE));
		this.addState(new TopGameAvalancheReelsDropNewState(this, AvalancheReelsModule.DROPNEW_STATE));
	}

	protected onRemovingSymbolsFinished(eventID: string, symbols: SymbolPosition[]): void {

	}

	protected onFillingVoidsFinished(eventID: string, reelNr: number): void {
	}

}



// WEBPACK FOOTER //
// ./src/topreels/TopReelsModule.ts